export default __webpack_public_path__ + "static/network-4-f2bbeb205a59116c63844328e6797592.png";